import * as common from '@/store/common/mutation-types';

export const SEARCH_PARAM = 'SEARCH_PARAM';
export const STATE_INIT = 'STATE_INIT';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SEARCH_PART_POP_PARAMS = 'SEARCH_PART_POP_PARAMS';

export default {
	...common,
	SEARCH_PARAM,
	STATE_INIT,
	DEFAULT_ASSIGN,
	SEARCH_PART_POP_PARAMS
};
